import { Stack } from '@mantine/core'
import { ReactNode, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getFacility } from 'app/state/ducks/facilities/selectors'
import { loadOneDeal } from 'app/state/ducks/deals/thunks'
import { getDeal, getDeals } from 'app/state/ducks/deals/selectors'
import { DealParams } from 'app/models/deal-params'
import { LetterOfCreditParams } from 'app/models/letter-of-credit'
import { getLetterOfCredits, getLetterofCreditsLoader } from 'app/state/ducks/letters-of-credits/selectors'
import { getEntities } from 'app/state/ducks/entities/selectors'
import ExpandableMantineTable from './table-locs'
import { buildFacilityDetailSectionForFacilityTabs } from 'app/views/components/functions/buildDetailsObjects'
import { DetailSectionHeader } from 'app/views/components/detailSections/detail-section-header'
import { DetailSection } from 'app/views/components/detailSections/detail-section'
import { useNavigate } from 'react-router'
import { DataBoxLayout } from 'app/views/components/detailSections/data-box-layout'

export default function FacilityLocContent(): JSX.Element {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [deal, setDeal] = useState<DealParams | undefined>(undefined)
  const lettersOfCreditLoader = useSelector(getLetterofCreditsLoader)
  const [globalLoading, setGlobalLoading] = useState(false)

  useEffect(() => {
    setGlobalLoading(lettersOfCreditLoader)
  }, [lettersOfCreditLoader])

  const letterOfCredits: LetterOfCreditParams[] | undefined =
    useSelector(getLetterOfCredits)
  const facility = useSelector(getFacility)
  const deals = useSelector(getDeals)
  const currentDeal = useSelector(getDeal)
  const entities = useSelector(getEntities)
  const entityIdToName = new Map<string, string>()

  useEffect(() => {
    if (!facility || !deals) {
      return
    }
    const deal = deals.find(deal => deal.id === facility.dealId.id)
    if (deal) {
      setDeal(deal)
    } else {
      dispatch(loadOneDeal(facility.dealId.id, 'Terminated'))
    }
  }, [facility, deals])

  useEffect(() => {
    if (!currentDeal) {
      return
    }
    setDeal(currentDeal)
  }, [currentDeal])

  if (Array.isArray(entities)) {
    for (const entity of entities) {
      if (entity.id) {
        entityIdToName.set(entity.id, entity.entityName)
      }
    }
  }

  const facilityDetails = buildFacilityDetailSectionForFacilityTabs(facility, entities, deal, navigate)

  const renderDetailSection = (headerText: string, detailObjArr: any) => (
    <>
      <DetailSectionHeader headerText={headerText} />
      <DetailSection detailObjArr={detailObjArr} columnCount={4} />
    </>
  )


  const renderTableSection = (headerText: string, tableSection: ReactNode) => (
    <>
      <DetailSectionHeader headerText={headerText} />
      {tableSection}
    </>
  )

  return (
    <Stack w="100%">
      <DataBoxLayout
        tableSections={[renderTableSection('Letters of Credit List', <ExpandableMantineTable locs={letterOfCredits} globalLoading={globalLoading} />)]}
        sections={[
          [renderDetailSection('Details', facilityDetails)]
        ]}
        tablePosition='top'
      />
    </Stack>
  )
}
